// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { create } from "@bufbuild/protobuf"
import * as Actions from "../actions"
import * as TimelineSlice from "../slices/timeline"
import { showSnackBar } from "../../snackbar/actions"
import { executorMutation, Init, timelineService } from "../../../app/rpc"
import {
  ImmediatelyDeleteTimeRowsRequestSchema,
  ImmediatelyDeleteTimeRowsResponse
} from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

type ImmediatelyDeleteTimeRowsRpc = (request: Init<typeof ImmediatelyDeleteTimeRowsRequestSchema>) => Observable<ImmediatelyDeleteTimeRowsResponse>

export const immediatelyDeleteTimeRows = (immediatelyDeleteTimeRowsRpc: ImmediatelyDeleteTimeRowsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.immediatelyDeleteTimeRows.match),
      mergeMap(({ payload: request }) => immediatelyDeleteTimeRowsRpc(request)
        .pipe(
          map(_ => TimelineSlice.deleteTimeRows(request.timeRowIds ?? [])),
          catchError(_ => of(showSnackBar({
            message: t({ id: "msg_immediately_delete_time_rows_failed", message: "Failed to delete. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
            messageType: "ERROR",
          })))),
      )
    )

const immediatelyDeleteTimeRowsRpc = (request: Init<typeof ImmediatelyDeleteTimeRowsRequestSchema>): Observable<ImmediatelyDeleteTimeRowsResponse> =>
  executorMutation(() => timelineService.immediatelyDeleteTimeRows(create(ImmediatelyDeleteTimeRowsRequestSchema, request)))

export default immediatelyDeleteTimeRows(immediatelyDeleteTimeRowsRpc)
